import { Component, OnInit, Input } from '@angular/core';
import {Hotel} from '../../api/model/hotel/hotel.model';

@Component({
    selector: 'stay-mgmt-front-desk',
    templateUrl: './front-desk.component.html',
    styleUrls: ['./front-desk.component.scss']
})
export class FrontDeskComponent implements OnInit {

    @Input() messages;
    @Input() overrideFont: boolean;
    private _hotel: Hotel;
    showUKMessageDisclaimer = false;
    showFrontDeskNumber = false;

    constructor() {}

    @Input()
    set hotel(hotel: Hotel) {
        if (hotel) {
          this._hotel = hotel;
          this._setShowUKDisclaimer();
        }
    }
    get hotel(): Hotel {
      return this._hotel;
    }

    /**
     * Here the UK disclaimer is a translatable message, that will display on under the front desk phone number
     * only when the hotel's country code is GB and the phone number is the 44-871 || 44-0871 number.
     * The boolean, showUKMessageDisclaimer is used to enable that logic of when to display it.
     *
     * @memberof FrontDeskComponent
     */
    private _setShowUKDisclaimer() {

    if (this.hotel.frontDeskNumber) {
      this.showFrontDeskNumber = true;
      if (this.hotel.frontDeskNumber.toString().includes('44-0871')
      || this.hotel.frontDeskNumber.toString().includes('44-871')
      && (this.hotel.address && this.hotel.address.countryCode && this.hotel.address.countryCode.toUpperCase() === 'GB')) {
          this.showUKMessageDisclaimer = true;
        } else {
          this.showUKMessageDisclaimer = false;
        }
    } else {
      this.showFrontDeskNumber = false;
      }
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/front-desk/front-desk.component.ts